
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {Obi03Illustration as Obi03IllustrationElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-03-illustration.js';
 
 
 

 
 export const Obi03Illustration = createComponent({
   react: React,
   tagName: 'obi-03-illustration',
   elementClass: Obi03IllustrationElement,
   events: {
     
   }
  });
 
 